import type { TranscriptorConsultation } from '../config';

export type ProcessingStep = 'transcribing' | 'filling' | 'checking';

export type ProcessingStage = ProcessingStep | 'done' | 'failed';

export const PROCESSING_STEPS: ProcessingStep[] = [
  'transcribing',
  'filling',
  'checking',
];

// Lab approximation from what the encounter exposes: no transcript yet is
// recognition, documents still generating is filling, and the time between
// the last document and the encounter's own finish (the final pass, the
// evaluation) is the final check.
export const getProcessingStage = ({
  status,
  transcriptChunks,
  documents,
}: Pick<
  TranscriptorConsultation,
  'status' | 'transcriptChunks' | 'documents'
>): ProcessingStage => {
  if (status === 'failed') {
    return 'failed';
  }
  if (status === 'succeeded') {
    return 'done';
  }
  const generating =
    !documents.length ||
    documents.some(
      (document) =>
        document.status === 'pending' || document.status === 'generating',
    );
  if (!transcriptChunks.length && generating) {
    return 'transcribing';
  }
  return generating ? 'filling' : 'checking';
};
